import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetDescription,
} from './ui/sheet';
import { getHelpContent } from '../lib/help-content';

/**
 * Contextual help panel — slides in from the right.
 *
 * @param {{ open: boolean, onClose: () => void }} props
 */
const HelpPanel = ({ open, onClose }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const content = getHelpContent(location.pathname, i18n.language);

    return (
        <Sheet open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
            <SheetContent side="right" className="w-80 sm:max-w-sm flex flex-col gap-0 p-0">
                <SheetHeader className="px-6 pt-6 pb-4 border-b border-border flex-shrink-0">
                    <SheetTitle>
                        {content ? content.title : t('nav.help_button_label')}
                    </SheetTitle>
                    <SheetDescription className="sr-only">
                        {t('nav.help_button_label')}
                    </SheetDescription>
                </SheetHeader>

                <div className="flex-1 overflow-y-auto px-6 py-4">
                    {content ? (
                        <div className="space-y-4">
                            {content.sections.map((section) => (
                                <div key={section.heading} className="space-y-1">
                                    <h3 className="text-sm font-semibold">{section.heading}</h3>
                                    <p className="text-sm text-muted-foreground leading-relaxed">
                                        {section.text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-sm text-muted-foreground leading-relaxed">
                            {t('nav.help_no_content')}
                        </p>
                    )}
                </div>

                <div className="px-6 py-4 border-t border-border flex-shrink-0">
                    <p className="text-xs text-muted-foreground leading-relaxed">
                        {t('nav.help_contact_cta')}
                    </p>
                </div>
            </SheetContent>
        </Sheet>
    );
};

export default HelpPanel;
